module.exports = __webpack_public_path__ + "static/assets/46dea925d7c7531eed380aa00ec97bd5.png";